import { auth } from "../server/firebase";

const FIREBASE_USER_KEY = "firebaseUser";
const FIREBASE_TOKEN_KEY = "firebaseToken";

const toAsciiHeader = (value) =>
  String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^\x20-\x7E]/g, " ")
    .trim();

export const persistFirebaseSession = (userAuth, appUser = {}) => {
  if (!userAuth) return;

  const payload = {
    uid: userAuth.uid,
    email: String(userAuth.email || appUser.email || "")
      .toLowerCase()
      .trim(),
    nombre: appUser.nombre || userAuth.displayName || "",
  };

  localStorage.setItem(FIREBASE_USER_KEY, JSON.stringify(payload));

  userAuth
    .getIdToken()
    .then((idToken) => {
      localStorage.setItem(FIREBASE_TOKEN_KEY, idToken);
    })
    .catch((error) => {
      console.log("No se pudo obtener el token de Firebase:", error);
    });
};

export const persistAppUserSession = (usuario) => {
  if (!usuario) return;

  const payload = {
    uid: usuario.id || usuario.uid || "",
    email: String(usuario.email || usuario.correo || "")
      .toLowerCase()
      .trim(),
    nombre: usuario.nombre || "",
  };

  localStorage.setItem(FIREBASE_USER_KEY, JSON.stringify(payload));
};

export const clearFirebaseSession = () => {
  localStorage.removeItem(FIREBASE_USER_KEY);
  localStorage.removeItem(FIREBASE_TOKEN_KEY);
};

export const getStoredFirebaseUser = () => {
  try {
    return JSON.parse(localStorage.getItem(FIREBASE_USER_KEY) || "null");
  } catch (error) {
    return null;
  }
};

export const getFirebaseIdentityHeaders = () => {
  const headers = {};
  const currentUser = auth.currentUser;
  const storedUser = getStoredFirebaseUser();
  const storedToken = localStorage.getItem(FIREBASE_TOKEN_KEY);

  const email = (currentUser && currentUser.email) || (storedUser && storedUser.email);
  const uid = (currentUser && currentUser.uid) || (storedUser && storedUser.uid);
  const nombre =
    (currentUser && currentUser.displayName) || (storedUser && storedUser.nombre);

  if (storedToken) {
    headers.Authorization = `Bearer ${storedToken}`;
  }
  if (email) {
    headers["X-User-Email"] = email;
  }
  if (uid) {
    headers["X-User-Uid"] = uid;
  }
  if (nombre) {
    headers["X-User-Name"] = toAsciiHeader(nombre);
  }

  return headers;
};

export const applyFirebaseAuthHeaders = async (config) => {
  const nextConfig = config || {};
  nextConfig.headers = nextConfig.headers || {};

  const currentUser = auth.currentUser;
  const storedUser = getStoredFirebaseUser();

  if (currentUser) {
    try {
      const idToken = await currentUser.getIdToken();
      nextConfig.headers.Authorization = `Bearer ${idToken}`;
      localStorage.setItem(FIREBASE_TOKEN_KEY, idToken);
    } catch (error) {
      const storedToken = localStorage.getItem(FIREBASE_TOKEN_KEY);
      if (storedToken) {
        nextConfig.headers.Authorization = `Bearer ${storedToken}`;
      }
    }

    if (currentUser.email) {
      nextConfig.headers["X-User-Email"] = currentUser.email;
    }
    if (currentUser.uid) {
      nextConfig.headers["X-User-Uid"] = currentUser.uid;
    }
    if (currentUser.displayName) {
      nextConfig.headers["X-User-Name"] = toAsciiHeader(currentUser.displayName);
    }

    return nextConfig;
  }

  const storedToken = localStorage.getItem(FIREBASE_TOKEN_KEY);
  if (storedToken) {
    nextConfig.headers.Authorization = `Bearer ${storedToken}`;
  }

  if (storedUser) {
    if (storedUser.email) {
      nextConfig.headers["X-User-Email"] = storedUser.email;
    }
    if (storedUser.uid) {
      nextConfig.headers["X-User-Uid"] = storedUser.uid;
    }
    if (storedUser.nombre) {
      nextConfig.headers["X-User-Name"] = toAsciiHeader(storedUser.nombre);
    }
  }

  return nextConfig;
};
